import { TotalProductItem } from 'graphql-api/baskets-api-interfaces';
import { DabData } from 'graphql-api/gql-api-interfaces';

export const updateDabWithBasketItems = (
  products: TotalProductItem[] | undefined,
  dabData: DabData[] | null | undefined,
) => {
  const productsInBasketMap = new Map(
    products?.map((product) => [
      `${product.brandId}-${product.productId}`,
      product,
    ]),
  );
  if (productsInBasketMap.size > 0 && dabData && dabData.length > 0) {
    return dabData.map((dabEntry) => ({
      ...dabEntry,
      basketItemsQuantity:
        productsInBasketMap.get(`${dabEntry.brandId}-${dabEntry.productId}`)
          ?.quantity ?? null,
    }));
  }
  return dabData ?? [];
};
